import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '艺术分类',
    links: [
      { name: '西方古典绘画', path: '/category/western-classical' },
      { name: '东方艺术', path: '/category/eastern-art' },
      { name: '现代摄影', path: '/category/modern-photography' },
      { name: '雕塑艺术', path: '/category/sculpture' },
      { name: '当代艺术', path: '/category/contemporary-art' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { name: '品牌介绍', path: '/about' },
      { name: '学术声誉', path: '/about' },
      { name: '联系我们', path: '/about' },
    ],
  },
  {
    title: '法律信息',
    links: [
      { name: '隐私政策', path: '#' },
      { name: '使用条款', path: '#' },
      { name: '版权声明', path: '#' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-[#2D2420] text-white/80">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link
              to="/"
              className="text-xl text-white font-heading tracking-wide"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              裸体艺术解析
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-white/60">
              专注于女性裸体艺术史与美学研究的深度内容平台，致力于为中文读者提供严谨、专业的艺术分析。
            </p>
          </div>
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h3 className="text-sm font-medium text-white mb-4">{group.title}</h3>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.name}>
                    {link.path.startsWith('#') ? (
                      <a
                        href={link.path}
                        className="text-sm text-white/60 hover:text-white transition-colors duration-200"
                      >
                        {link.name}
                      </a>
                    ) : (
                      <Link
                        to={link.path}
                        className="text-sm text-white/60 hover:text-white transition-colors duration-200"
                      >
                        {link.name}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/50">
            &copy; {new Date().getFullYear()} 女性裸体艺术解析. 保留所有权利.
          </p>
          <p className="text-xs text-white/50">
            本站所有内容仅供学术研究参考
          </p>
        </div>
      </div>
    </footer>
  );
}